export default "__VITE_ASSET__DGnzcGZk__"